import {RESET_GAME_ACTION, MARK_LETTERS_AS_USED_ACTION} from '../constants';

const usedLettersReducer = (state = [], action) => {
    switch (action.type) {
        case RESET_GAME_ACTION:
            return [];
        case MARK_LETTERS_AS_USED_ACTION:
            return [...state, ...action.letterIds];
        default:
            return state;
    }
};
export default usedLettersReducer;
